"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _classnames = _interopRequireDefault(require("classnames"));

var _tooltip = _interopRequireDefault(require("./tooltip"));

var _svg = _interopRequireDefault(require("./svg"));

require("./form-field.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FormField = function FormField(props) {
  var infoTooltip;

  if (props.infoText) {
    infoTooltip = _react["default"].createElement(_tooltip["default"], {
      className: "infoText",
      placement: "right",
      trigger: ['hover', 'click'],
      mouseLeaveDelay: 0.3,
      infoText: props.infoText
    }, _react["default"].createElement(_svg["default"], {
      id: "info"
    }));
  }

  var label = props.label ? _react["default"].createElement("div", {
    className: "label"
  }, props.label, infoTooltip) : null;
  var error;

  if (!_lodash["default"].get(props.meta, 'valid') && _lodash["default"].get(props.meta, 'touched')) {
    error = _lodash["default"].get(props.meta, 'error');
  }

  var classNames = (0, _classnames["default"])('FormField', props.className, {
    hasError: !_lodash["default"].get(props.meta, 'valid') && _lodash["default"].get(props.meta, 'touched')
  });
  return _react["default"].createElement("div", {
    className: classNames
  }, label, props.children, _react["default"].createElement("div", {
    className: "error"
  }, error));
};

FormField.propTypes = {
  label: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  className: _propTypes["default"].string,
  meta: _propTypes["default"].shape({
    valid: _propTypes["default"].bool,
    error: _propTypes["default"].string,
    touched: _propTypes["default"].bool
  }),
  infoText: _propTypes["default"].string
};
FormField.defaultProps = {
  label: null,
  className: '',
  meta: {
    valid: true,
    error: null,
    touched: false
  },
  infoText: null
};
var _default = FormField;
exports["default"] = _default;